import { useEffect, useState } from 'react'

import type { RecipeUUID } from '@library/menu-service'

type UseRecipeDetailSelectedPortionInput = {
  numPortions: number
  recipeUuid: RecipeUUID | null
}

export const useRecipeDetailSelectedPortion = ({
  numPortions,
  recipeUuid,
}: UseRecipeDetailSelectedPortionInput) => {
  // Interim local state for NP-8446; rewire to recipe-level basket state after NP-8422.
  const [selectedNumPortions, setSelectedNumPortions] = useState(numPortions)

  useEffect(() => {
    setSelectedNumPortions(numPortions)
  }, [numPortions, recipeUuid])

  return {
    selectedNumPortions,
    setSelectedNumPortions,
  }
}
